import { Box, useTheme } from "@mui/material";

import { UnstyledLink } from "./Routing/UnstyledLink";

type Props = {
  size: "sm" | "md";
};

export const Logo = ({ size }: Props): React.ReactNode => {
  const theme = useTheme();
  return (
    <UnstyledLink to="/">
      <Box display="flex" alignItems="center">
        <Box
          component="img"
          alt="vivelo.ai"
          src="/images/logo.svg"
          sx={{
            // The SVG viewBox is trimmed to the artwork, so height alone
            // determines the rendered size.
            height: theme.spacing(size === "sm" ? 8 : 11),
            width: "auto",
          }}
        />
      </Box>
    </UnstyledLink>
  );
};
